import React, { FunctionComponent } from 'react'

export type Props = {
  width?: number
  fill?: string
}
export type Functions = {}

export type AllProps = Props & Functions

export const MobillyLogo: FunctionComponent<AllProps> = ({ width, fill }) => (
  <svg width={`${width || 150}px`} viewBox="0 0 236.15 76.42">
    <g fill={fill || '#ffffff'}>
      <g>
        <path d="M31.19,37.11c-10.86,0-19.66,8.8-19.66,19.66s8.8,19.66,19.66,19.66,19.66-8.8,19.66-19.66-8.8-19.66-19.66-19.66ZM41.76,67.17h-3.53v-13.9l-6.35,10.14h-1.43l-6.35-10.14v13.9h-3.5v-20.22h3.5l7.06,11.16,7.06-11.16h3.53v20.22Z"/>
        <g>
          <path d="M31.19,0C19.75.04,9.08,3.32,0,8.95l2.44,3.85C10.81,7.62,20.65,4.6,31.19,4.56c10.54.04,20.38,3.06,28.75,8.24l2.44-3.85C53.3,3.32,42.62.04,31.19,0Z"/>
          <path d="M13,29.5l2.44,3.85c4.61-2.8,9.99-4.44,15.75-4.48,5.76.04,11.14,1.68,15.75,4.48l2.44-3.85c-5.31-3.24-11.53-5.15-18.19-5.19-6.66.04-12.87,1.94-18.19,5.19Z"/>
          <path d="M6.47,19.18l2.44,3.85c6.5-4,14.12-6.32,22.28-6.36,8.16.04,15.78,2.36,22.28,6.36l2.44-3.85c-7.2-4.44-15.66-7.04-24.71-7.07-9.06.04-17.52,2.63-24.71,7.07Z"/>
        </g>
      </g>
      <g>
        <path d="M118.49,61.33c0,3.76-2.87,5.84-7.18,5.84h-6.72v-20.22h6.23c4.21,0,6.52,2.25,6.52,5.44,0,1.65-.79,3.05-2.02,3.98,1.8,1.02,3.16,2.73,3.16,4.96M108.09,54.93h2.73c1.88,0,3.02-.71,3.02-2.33,0-1.54-1.14-2.33-3.02-2.33h-2.73v4.67ZM114.99,61.13c0-1.71-1.28-2.9-3.59-2.9h-3.31v5.64h3.22c2.39,0,3.67-1.02,3.67-2.73"/>
        <path d="M64.21,57.06c0-5.99,4.71-10.81,10.7-10.81s10.73,4.82,10.73,10.81-4.71,10.81-10.73,10.81c-5.98,0-10.7-4.83-10.7-10.81M81.95,57.06c0-4.03-2.96-7.37-7.05-7.37s-7.05,3.35-7.05,7.37,2.96,7.38,7.05,7.38,7.05-3.35,7.05-7.38"/>
        <rect x="137.41" y="46.96" width="3.51" height="20.22"/>
        <polygon points="173.3 63.87 173.3 67.17 161.54 67.17 161.54 46.96 165.04 46.96 165.04 63.87 173.3 63.87"/>
        <polygon points="203.16 63.87 203.16 67.17 191.4 67.17 191.4 46.96 194.91 46.96 194.91 63.87 203.16 63.87"/>
        <polygon points="236.15 46.96 228.72 59.05 228.72 67.17 225.22 67.17 225.22 59.05 217.79 46.96 221.74 46.96 226.95 55.44 232.19 46.96 236.15 46.96"/>
      </g>
    </g>
  </svg>
)
